import React, { useState, useEffect, useContext } from 'react'
import axios from 'axios'
import moment from 'moment'
import Autocomplete from '@material-ui/lab/Autocomplete';
import TextField from '@material-ui/core/TextField';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControl from '@material-ui/core/FormControl';
import { UserContext } from '../../UserContext'
import AuthGroupWrapper from '../Auth/AuthGroupWrapper'

// Just the sales teams in the admin...

const SalesTeams = (props) => {

  const [edit, setEdit] = useState('')

  const { activeUser, setActiveUser } = useContext(UserContext);

  // eslint-disable-next-line
  const { team_id, team_name, has_team_ppw, team_ppw, cashPpw, teamLocation, int1, invId, invModel, invName, loan1, modId, loan_id1, modMake, modModel, modSize, term1, term2, int2, loan2, loan_id2, term3, int3, loan3, loan_id3, hasNest, loanChangeSize, hasAdder, specialLoanIncrease, loanOptions, loanOptions2, priceOptions, user, timeStamp, hasPpa } = props.salesTeam

  const { loanProducts, modules, inverters } = props
  const [newUser, setNewUser] = useState()
  const [timer, setTimer] = useState()
  const [loans] = useState([])
  const [loans2] = useState([])
  const [teamName, setTeamName] = useState(team_name)
  const [location, setLocation] = useState(teamLocation)
  const [loanId1, setLoanId1] = useState(loan_id1)
  const [loanId2, setLoanId2] = useState(loan_id2)
  const [loanId3, setLoanId3] = useState(loan_id3)
  const [loanChange, setLoanChange] = useState(loanChangeSize)
  const [teamPpw, setTeamPpw] = useState(null)
  const [hasTeamPpw, setHasTeamPpw] = useState(has_team_ppw)
  const [teamCashPpw, setTeamCashPpw] = useState(+cashPpw)
  const [nest, setNest] = useState(hasNest)
  const [ppa, setPpa] = useState(hasPpa)
  const [adder, setAdder] = useState(hasAdder)
  const [inverterId, setInverterId] = useState(invId)
  const [moduleId, setModuleId] = useState(modId)
  const [loanIncrease, setLoanIncrease] = useState(specialLoanIncrease)
  const [loanCall, setLoanCall] = useState([])
  const [loanOption1, setLoanOption1] = useState(loans)
  const [loanOption2, setLoanOption2] = useState(loans2)
  const [pricingOptions, setPricingOptions] = useState(priceOptions)
  const [pricingOption1, setPricingOption1] = useState(priceOptions[0])
  const [pricingOption2, setPricingOption2] = useState(priceOptions[1])
  const [pricingOption3, setPricingOption3] = useState(priceOptions[2])
  const [pricingOption4, setPricingOption4] = useState(priceOptions[3])
  let prices = '0,0,0,0'
  if (+priceOptions[0] > 0) {
    prices = `${pricingOption1},${pricingOption2},${pricingOption3},${pricingOption4}`
  }

  useEffect(() => {
    setNewUser(`${activeUser.attributes.given_name} ${activeUser.attributes.family_name}`)
  }, [])

  const time = () => {
    setTimer(moment().format('MM/DD/YY, h:mm a'))
  }


  useEffect(() => {
    loanProducts.forEach(function (i) {
      for (let j = 0; j <= loanOptions.length; j++) {
        if (i.loanId === loanOptions[j]) {
          loans.push(i)
        }
      }
      for (let j = 0; j <= loanOptions2.length; j++) {
        if (i.loanId === loanOptions2[j]) {
          loans2.push(i)
        }
      }
    })
  }, [loanProducts])

  let options1 = loanOption1.filter(option => {
    return +option.loanId > 0
  }).map(item => item.loanId)

  let options2 = loanOption2.filter(option => {
    return +option.loanId > 0
  }).map(item => item.loanId)

  let mappedOptions1 = loanOption1.map((loans, i) => {
    return <div key={i}>
      <span  > {+loans.isPpa === 1 ? `${loans.loanName} ${loans.ppaRate} ${(+loans.ppaEscalator * 100).toFixed(2)}%` : `${loans.loanName} ${loans.loanTerm} year ${loans.loanInterest}%`}</span>
    </div>
  })

  let mappedOptions2 = loanOption2.map((loans, i) => {
    return <div key={i} >
      <span > {`${loans.loanName} ${(+loans.itc * 100).toLocaleString(undefined)}% ${loans.loanTerm} year ${loans.loanInterest}%`}</span>
    </div>
  })

  let states = [
    { state: "Alabama" },
    { state: "Alaska" },
    { state: "Arizona" },
    { state: "Arkansas" },
    { state: "California" },
    { state: "Colorado" },
    { state: "Connecticut" },
    { state: "Delaware" },
    { state: "Florida" },
    { state: "Georgia" },
    { state: "Hawaii" },
    { state: "Idaho" },
    { state: "Illinois" },
    { state: "Indiana" },
    { state: "Iowa" },
    { state: "Kansas" },
    { state: "Kentucky" },
    { state: "Louisiana" },
    { state: "Maine" },
    { state: "Maryland" },
    { state: "Massachusetts" },
    { state: "Michigan" },
    { state: "Minnesota" },
    { state: "Mississippi" },
    { state: "Missouri" },
    { state: "Montana" },
    { state: "Nebraska" },
    { state: "Nevada" },
    { state: "New Hampshire" },
    { state: "New Jersey" },
    { state: "New Mexico" },
    { state: "New York" },
    { state: "North Carolina" },
    { state: "North Dakota" },
    { state: "Ohio" },
    { state: "Oklahoma" },
    { state: "Oregon" },
    { state: "Pennsylvania" },
    { state: "Rhode Island" },
    { state: "South Carolina" },
    { state: "South Dakota" },
    { state: "Tennessee" },
    { state: "Texas" },
    { state: "Utah" },
    { state: "Vermont" },
    { state: "Virginia" },
    { state: "Washington" },
    { state: "West Virginia" },
    { state: "Wisconsin" },
    { state: "Wyoming" }
  ]

  useEffect(() => {
    if (team_ppw) {
      return setTeamPpw(team_ppw)
    } setTeamPpw(null)
  }, [props.salesTeam])

  useEffect(() => {
    if (teamPpw > 0) {
      return setHasTeamPpw(1)
    } return setHasTeamPpw(0)
  })

  useEffect(() => {
    if (loanId3 < 1) {
      setLoanChange(0)
    }
  })

  const handleChange = (event) => {
    setLoanIncrease(event.target.value);
  };
  const handleChangeAdder = (event) => {
    setAdder(event.target.value);
  };
  const handleChangeNest = (event) => {
    setNest(event.target.value);
  };
  const handleChangePpa = (event) => {
    setPpa(event.target.value);
  };

  const updateSalesTeam = () => {
    axios.post(`https://dev.iondeveloper.com/api/proposal/proposal-tool/?api_key=${process.env.REACT_APP_API_KEY}`, { method: 'update_sales_team', team_name: teamName, loan_id1: loanId1, loan_id2: loanId2, has_team_ppw: hasTeamPpw, team_ppw: teamPpw, has_adder: adder, adder_id: 1, team_id: team_id, has_nest: nest, cash_ppw: teamCashPpw, mod_id: moduleId, inv_id: inverterId, team_location: location, loan_id1_2: loanId3, loan_change_size: loanChange, special_loan_increase: loanIncrease, price_options: prices, loan_options: options1.join(), loan_options_2: options2.join(), user: newUser, time_stamp: timer, ppa: ppa })
      .then((res) => {
        props.getSalesTeams()
        console.log(res)
      })
  }

  const findLoan = (id) => {
    return loanProducts.find(loan => loan.loanId === id)
  }

  const setPpws = (cashPpw) => {
    const dealerFee = +findLoan(loan_id1).dealerFee || 0.70
    const ppwWithDealerFee = (+cashPpw / +dealerFee)
    setTeamCashPpw(cashPpw)
    setTeamPpw(ppwWithDealerFee)
  }

  return (
    <div className='itemsTeam'>
      <div>
        <h3>{team_name} </h3>
      </div>
      {edit ? (
        <>
          <div className='subItemsTeam'>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <div>
                <TextField className='input' style={{ width: 225 }} label="Team Name" variant="filled" size="small" margin="dense" helperText={team_name} onChange={e => setTeamName(e.target.value)}></TextField>
              </div>
              <div>
                {/* <span>Location (state): {teamLocation} </span> */}
                <Autocomplete disableClearable id="tags-outlined-state" options={states} getOptionSelected={(option, value) => option.value === value.value} getOptionLabel={(option) => `${option.state}`} value={states.state} onChange={(event, value) => setLocation(value.state)} style={{ width: 225 }}
                  renderInput={(params) => (
                    <TextField className='input'  {...params} variant="filled" size="small" label="State" margin="dense" width="80%" helperText={teamLocation}
                    />
                  )}
                />
              </div>
              <div>
                <Autocomplete disableClearable id="tags-outlined-modules" options={modules} getOptionSelected={(option, value) => option.value === value.value} getOptionLabel={(option) => `${option.make} ${option.model} ${option.size}`} value={modules.modId} onChange={(event, value) => setModuleId(value.modId)} style={{ width: 225 }}
                  renderInput={(params) => (
                    <TextField className='input'  {...params} variant="filled" size="small" label="Module" margin="dense" width="80%" helperText={`${modMake} ${modModel} ${modSize}`}
                    />
                  )}
                />
              </div>
              <div>
                <Autocomplete disableClearable id="tags-outlined-inverters" options={inverters} getOptionSelected={(option, value) => option.value === value.value} getOptionLabel={(option) => `${option.make} ${option.model}`} value={inverters.invId} onChange={(event, value) => setInverterId(value.invId)} style={{ width: 225 }}
                  renderInput={(params) => (
                    <TextField className='input'  {...params} variant="filled" size="small" label="Inverter" margin="dense" width="80%" helperText={`${invName} ${invModel}`}
                    />
                  )}
                />
              </div>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <div>
              <TextField className='input' disabled style={{ width: 225 }} label="PPW" variant="filled" size="small" margin="dense" helperText={`$${team_ppw}/watt`}></TextField>
              </div>
              <div>
                <TextField className='input' style={{ width: 225 }} label="Cash PPW" variant="filled" size="small" margin="dense" helperText={`$${cashPpw}/watt`} onChange={e => setPpws(e.target.value)}></TextField>
              </div>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <div>
                <Autocomplete disableClearable id="tags-outlined-loan-1" options={loanProducts} groupBy={(option) => option.loanName} getOptionSelected={(option, value) => option.value === value.value} getOptionLabel={(option) => +option.isPpa === 1 ? `${option.loanName} ${option.ppaRate} ${(+option.ppaEscalator * 100).toFixed(2)}%` : `${option.loanName} ${option.loanTerm}yr ${option.loanInterest}%`} value={loanProducts.loanId} onChange={(event, value) => setLoanId1(value.loanId)} style={{ width: 225 }}
                  renderInput={(params) => (
                    <TextField className='input' {...params} variant="filled" size="small" label="Loan Option 1" margin="dense" helperText={`${loan1} ${term1}yr ${int1}%`} fullWidth
                    />
                  )}
                />
              </div>
              <div>
                <Autocomplete disableClearable id="tags-outlined-loan-3" options={loanProducts} groupBy={(option) => option.loanName} getOptionSelected={(option, value) => option.value === value.value} getOptionLabel={(option) => +option.isPpa === 1 ? `${option.loanName} ${option.ppaRate} ${(+option.ppaEscalator * 100).toFixed(2)}%` : `${option.loanName} ${option.loanTerm}yr ${option.loanInterest}%`} value={loanProducts.loanId} onChange={(event, value) => setLoanId3(value.loanId)} style={{ width: 225 }}
                  renderInput={(params) => (
                    <TextField className='input' {...params} variant="filled" size="small" label="Option 1 Secondary" margin="dense" helperText={loanId3 > 0 ? `${loan3} ${term3}yr ${int3}%` : 'N/A'} fullWidth
                    />
                  )}
                />
              </div>
              <div>
                <TextField className='input' style={{ width: 225 }} label="Option 1 Threshold (watts)" variant="filled" size="small" margin="dense" helperText={loanChangeSize > 0 ? `${loanChangeSize} watts` : 'N/A'} onChange={e => setLoanChange(e.target.value)}></TextField>
              </div>
              <div>
                <Autocomplete style={{ width: 225 }} multiple disableClearable disableCloseOnSelect limitTags={4} groupBy={(option) => option.loanName} id="tags-outlined" defaultValue={loans} options={loanProducts} getOptionLabel={(option) => +option.isPpa === 1 ? `${option.loanName} ${option.ppaRate} ${(+option.ppaEscalator * 100).toFixed(2)}%` : `${option.loanName} ${option.loanTerm}yr ${option.loanInterest}%`} value={loanProducts.loanId} onChange={(event, value) => setLoanOption1(value)}
                  renderInput={(params) => (
                    <TextField className='input' {...params} variant="filled" size="small" label="Option 1 Choices" margin="dense" helperText={`Loan 1 Choices in Proposalist`} fullWidth
                    />
                  )}
                />
              </div>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <div>
                <Autocomplete disableClearable id="tags-outlined-loan-4" options={loanProducts} groupBy={(option) => option.loanName} getOptionSelected={(option, value) => option.value === value.value} getOptionLabel={(option) => +option.isPpa === 1 ? `${option.loanName} ${option.ppaRate} ${(+option.ppaEscalator * 100).toFixed(2)}%` : `${option.loanName} ${option.loanTerm}yr ${option.loanInterest}%`} value={loanProducts.loanId} onChange={(event, value) => setLoanId2(value.loanId)} style={{ width: 225 }}
                  renderInput={(params) => (
                    <TextField className='input' {...params} variant="filled" size="small" label="Loan Option 2" margin="dense" helperText={`${loan2} ${term2}yr ${int2}%`} fullWidth
                    />
                  )}
                />
              </div>
              <div>
                <Autocomplete style={{ width: 225 }} getOptionDisabled={(options) => (loanOption2.length > 2 ? true : false)} multiple disableClearable disableCloseOnSelect limitTags={4} groupBy={(option) => option.loanName} id="tags-outlined-loan-2-options" defaultValue={loans2} options={loanProducts} getOptionLabel={(option) => +option.isPpa === 1 ? `${option.loanName} ${option.ppaRate} ${(+option.ppaEscalator * 100).toFixed(2)}%` : `${option.loanName} ${option.loanTerm}yr ${option.loanInterest}%`} value={loanProducts.loanId} onChange={(event, value) => setLoanOption2(value)}
                  renderInput={(params) => (
                    <TextField className='input' {...params} variant="filled" size="small" label="Option 2 Choices" margin="dense" helperText={`Loan 2 Choices in Proposalist`} fullWidth
                    />
                  )}
                />
              </div>
            </div>
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-around', width: '100%' }}>
              <div>
                <FormControl fullWidth component="fieldset">
                  <span>Change PPW on special loan? </span>
                  <RadioGroup row aria-label="increase" name="loanIncrease" value={loanIncrease} onChange={handleChange}>
                    <FormControlLabel control={<Radio color="primary" />} label="Yes" value="1" name='loanIncrease' />
                    <FormControlLabel control={<Radio color="primary" />} label="No" value="0" name='loanIncrease' />
                  </RadioGroup>
                </FormControl>
              </div>
              <div>
                <FormControl fullWidth component="fieldset">
                  <span>$800 Customer Incentive: </span>
                  <RadioGroup row aria-label="adder" name="adder" value={adder} onChange={handleChangeAdder}>
                    <FormControlLabel control={<Radio color="primary" />} label="Rep" value="2" name='adder' />
                    <FormControlLabel control={<Radio color="primary" />} label="Customer" value="1" name='adder' />
                    <FormControlLabel control={<Radio color="primary" />} label="No" value="0" name='adder' />
                  </RadioGroup>
                </FormControl>
              </div>
              <div>
                <FormControl fullWidth component="fieldset">
                  <span>Default Nest: </span>
                  <RadioGroup row aria-label="nest" name="nest" value={nest} onChange={handleChangeNest}>
                    <FormControlLabel control={<Radio color="primary" />} type="radio" value="1" name='nest' label='Yes' />
                    <FormControlLabel control={<Radio color="primary" />} type="radio" value="0" name='nest' label='No' />
                  </RadioGroup>
                </FormControl>
              </div>
              <div>
                <FormControl fullWidth component="fieldset">
                  <span>PPA Products: </span>
                  <RadioGroup row aria-label="ppa" name="ppa" value={ppa} onChange={handleChangePpa}>
                    <FormControlLabel control={<Radio color="primary" />} type="radio" value="1" name='ppa' label='Yes' />
                    <FormControlLabel control={<Radio color="primary" />} type="radio" value="0" name='ppa' label='No' />
                  </RadioGroup>
                </FormControl>
              </div>
            </div>
            <button type='submit' onClick={() => { updateSalesTeam(); setEdit(!edit) }}>Update Sales Team</button>
            <button onClick={() => setEdit(!edit)}>Cancel</button>
          </div>
        </>
      ) : (
        <>
          <div className='subItemsTeam'>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'baseline' }}>
              <div>
                <span>Location (state): {teamLocation} </span>
              </div>
              <div>
                <span>Module: {modMake} {modModel} {modSize} </span>
              </div>
              <div>
                <span>Inverter: {invName} {invModel} </span>
              </div>
              <div>
                <span>Change PPW when special loan selected: </span>
                <span>{+specialLoanIncrease === 1 ? 'Yes' : 'No'}</span>
              </div>
              <div>
                <span>$800 Incentive: </span>
                <span>{adder === '1' ? `Yes - Customer` : adder === '2' ? `Yes - Rep` : 'No'}</span>
              </div>
              <div>
                <span>Default Nest: </span>
                <span>{+nest > 0 ? 'Yes' : 'No'}</span>
              </div>
              <div>
                <span>PPA Products: </span>
                <span>{+ppa > 0 ? 'Yes' : 'No'}</span>
              </div>
              <div>
                <span>PPW: {hasTeamPpw === 1 ? `${(+teamPpw).toLocaleString(undefined, { style: "currency", currency: "USD" })}/watt` : 'N/A'}</span>
              </div>
              <div>
                <span>Cash PPW: {(+cashPpw).toLocaleString(undefined, { style: "currency", currency: "USD" })}</span>
              </div>
              <div>
                <span>Plus Commission PPW: {(+teamPpw + .20).toLocaleString(undefined, { style: "currency", currency: "USD" })}</span>
              </div>
              <div>
                <span>Full Commission PPW: {(+teamPpw).toLocaleString(undefined, { style: "currency", currency: "USD" })}</span>
              </div>
              {teamLocation === 'Virginia' ? (
                <>
                  <div>
                    <span>Half Commission PPW: {(+teamPpw - .15).toLocaleString(undefined, { style: "currency", currency: "USD" })}</span>
                  </div>
                </>
              ) : (
                <div>
                  <span>Half Commission PPW: {(+teamPpw - .20).toLocaleString(undefined, { style: "currency", currency: "USD" })}</span>
                </div>
              )}
              <div>
                <span>No Commission PPW: {(+teamPpw - .40).toLocaleString(undefined, { style: "currency", currency: "USD" })}</span>
              </div>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'baseline' }}>
              <div>
                <span>Option 1: {loan1} {term1} {int1}% </span>
              </div>
              {+loan_id3 > 0 ? (
                <>
                  <div>
                    <span>Option 1 Secondary: {loan3} {term3} {int3}% </span>
                  </div>
                  <div>
                    <span>Option 1 Threshold: {loanChangeSize / 1000}kW </span>
                  </div>
                </>
              ) : (
                <>
                </>
              )}
              <div>
                <span>Option 1 Choices:</span>

                {mappedOptions1}

              </div>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'baseline' }}>
              <div>
                <span>Option 2: {loan2} {term2} {int2}% </span>
              </div>
              <div>
                <span>Option 2 Choices:</span>

                {mappedOptions2}

              </div>
            </div>
            {/* <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'baseline' }}>
              
            </div> */}

          </div>
          <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }} >
            <AuthGroupWrapper requiredGroups={['Super-Admin']}>
              <button onClick={() => { setEdit(!edit); time() }}>Edit {team_name} Info</button>
            </AuthGroupWrapper >
            <span>Last edited by {user} at {timeStamp}</span>
          </div>
        </>
      )
      }
    </div >
  )
}
export default SalesTeams
